(() => {
  const CHECKBOX_SELECTOR = '[data-return-policy-checkbox]';
  const CHECKOUT_SELECTOR = '[data-return-policy-checkout]';
  const ACK_ATTRIBUTE = 'Return policy acknowledged';

  const getCheckboxes = () => Array.from(document.querySelectorAll(CHECKBOX_SELECTOR));
  const isAcknowledged = () => getCheckboxes().some((checkbox) => checkbox.checked);

  const setButtonsState = (acknowledged) => {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach((button) => {
      if (acknowledged) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
      }
    });
  };

  const setErrorState = (show) => {
    document.querySelectorAll('[data-return-policy-error]').forEach((error) => {
      error.hidden = !show;
    });
  };

  const syncCheckboxes = (checked, source) => {
    getCheckboxes().forEach((checkbox) => {
      if (checkbox !== source) checkbox.checked = checked;
    });
  };

  const updateCartAttribute = async (checked) => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            [ACK_ATTRIBUTE]: checked ? 'Yes' : ''
          }
        })
      });

      if (!response.ok) throw new Error('Unable to save return-policy acknowledgement.');
    } catch (error) {
      console.warn('[deKor] Return policy acknowledgement could not be saved to cart.', error);
    }
  };

  const refresh = () => {
    const acknowledged = isAcknowledged();
    setButtonsState(acknowledged);
    if (acknowledged) setErrorState(false);
  };

  const handleChange = async (event) => {
    const checkbox = event.target.closest(CHECKBOX_SELECTOR);
    if (!checkbox) return;

    const checked = checkbox.checked;
    syncCheckboxes(checked, checkbox);
    setButtonsState(checked);
    setErrorState(false);
    await updateCartAttribute(checked);
  };

  const handleCheckoutAttempt = (event) => {
    const button = event.target.closest(CHECKOUT_SELECTOR);
    if (!button) return;

    if (!isAcknowledged()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setErrorState(true);
      const checkbox = getCheckboxes().find((item) => item.offsetParent !== null) || getCheckboxes()[0];
      checkbox?.focus({ preventScroll: true });
      checkbox?.closest('[data-return-policy-acknowledgement]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const observer = new MutationObserver(() => refresh());

  document.addEventListener('change', handleChange);
  document.addEventListener('click', handleCheckoutAttempt, true);
  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter?.matches?.(CHECKOUT_SELECTOR) && !isAcknowledged()) {
      event.preventDefault();
      setErrorState(true);
      getCheckboxes()[0]?.focus();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    refresh();
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
